import React from "react";
import {useTranslation} from "react-i18next";
import style from "./PrivacyToggle.module.css";

const PrivacyToggle = (props: any) => {
  const { t } = useTranslation();
  const textOffStyle = {
    color: !props.checked ? "#FFFFFF" : "#B1B0B0",
  };
  const textOnStyle = {
    color: props.checked ? "#FFFFFF" : "#B1B0B0",
  };

  return (
    <div className={style.switch}>
      <input type="checkbox" checked={props.checked} onChange={() => {}} />
      <span className={style.slider} onClick={props.onClick}>
        <div className={style.text} style={textOffStyle}>
          {t("Off")}
        </div>
        <div className={style.text} style={textOnStyle}>
          {t("On")}
        </div>
      </span>
    </div>
  );
};

export default PrivacyToggle;
